import { STATUS_TYPE } from '../../../enum';

export interface PartnerAuditLog {
  id: string;
  partnerId: string;
  partnerName?: string | null;
  partnerApiKeyId?: string | null;
  publicKey?: string | null;
  keyEnv?: string | null;
  keyStatus?: string | null;
  method: string;
  path: string;
  requestId?: string | null;
  action: string;
  customerId?: string | null;
  orderId?: string | null;
  result: string;
  errorCode?: string | null;
  ip?: string | null;
  createdAt: string;
}

export interface FindPartnerAuditLog {
  partnerId?: string;
  orderId?: string;
  from?: string;
  to?: string;
  limit?: number;
  skip?: number;
}

interface InitialState {
  data: PartnerAuditLog[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
  filters: {
    partnerId: string;
    orderId: string;
    from: string;
    to: string;
  };
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
  filters: {
    partnerId: '',
    orderId: '',
    from: '',
    to: '',
  },
};
